import React, { useState } from 'react';
import axios from 'axiosInstance';
import { Container, Form, Button, Alert } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import '../css/AuthLogin.css'; 

const Login = () => {
  const [form, setForm] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
const GoRegister = () => {
    navigate('/register'); 
  };
  const handleChange = (e) => {
    setForm({...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const response = await axios.post(process.env.REACT_APP_BACKEND_URL + '/api/auth/login', form, {
        headers: {
          'Content-Type': 'application/json',
        }
      });

      
      sessionStorage.setItem('token', response.data.token);
      sessionStorage.setItem('user', JSON.stringify(response.data.user));

      
      navigate('/'); 

    } catch (err) {
      if (err.response && err.response.status === 401) {
        setError('Email o contraseña incorrectos');
      } else {
        setError('Error en el servidor, inténtalo más tarde');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container style={{ maxWidth: '400px' }} className="mt-5">
      <h2 className="Titulo">Iniciar sesión</h2>
      {error && <Alert variant="danger">{error}</Alert>}

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Correo Gmail</Form.Label>
          <Form.Control
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            required
            placeholder="tuemail@gmail.com"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Contraseña</Form.Label>
          <Form.Control
            type="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            required
            placeholder="Contraseña"
          />
        </Form.Group>

        <Button  type="submit" disabled={isLoading} className="boton_accion_user w-100">
          {isLoading ? 'Ingresando...' : 'Ingresar'}
        </Button>
      </Form>

      <div className=" link mt-3 text-center">
        <Link to="/ContraseñaOlvidada">¿He olvidado mi contraseña?</Link>
      </div>
        <div className=" link mt-3 text-center">
            <Button variant="link" onClick={GoRegister}>
            ¿No tienes cuenta? Regístrate aquí
            </Button>
        </div>
    </Container>
  );
};

export default Login;
